module.exports = __webpack_public_path__ + "img/0106.8efa35b0.png";